<template>
  <div>
    <span class="title-form">{{ formName }}</span>
    <div class="mt-3">
      <div id="printOrderForm" class="mt-3">
        <div>
          <div>
            <!-- PATIENT INFORMATION -->
            <div>
              <span class="cs-title">PATIENT INFORMATION/ <i>THÔNG TIN BỆNH NHÂN</i></span>
              <div class="cs-flex">
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Full name/ <i>Họ tên</i></span>
                  <b-form-input class="cs-content" v-model="form.full_name" />
                </div>
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Birthday/ <i>Ngày sinh</i></span>
                  <b-form-input type="date" placeholder="Chọn ngày sinh" v-model="form.birthday" />
                </div>
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Phone Number/ <i>Điện thoại</i></span>
                  <b-form-input class="cs-content" v-model="form.phone_number" />
                </div>
              </div>
              <div class="cs-flex">
                <div class="col-12 col-sm-8">
                  <span class="cs-label">Address/ <i>Địa chỉ</i></span>
                  <b-form-input class="cs-content" v-model="form.address" />
                </div>
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Email</span>
                  <b-form-input class="cs-content" v-model="form.email" />
                </div>
              </div>
              <div class="cs-flex">
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Doctor/ <i>Bác sĩ</i></span>
                  <b-form-input class="cs-content" v-model="form.doctor_name" />
                </div>
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Clinic/Hospital/ <i>Phòng khám</i></span>
                  <b-form-input class="cs-content" v-model="form.clinic" />
                </div>
                <div class="col-12 col-sm-4">
                  <span class="cs-label">Doctor Phone Number/ <i>Điện thoại</i></span>
                  <b-form-input class="cs-content" v-model="form.doctor_phone_number" />
                </div>
              </div>
              <div class="cs-flex">
                <div class="col-12">
                  <span class="cs-label">Clinical information, diagnostic results/ <i>Thông tin lâm sàng, kết quả chẩn đoán</i></span>
                  <!-- <b-form-input class="cs-content" v-model="form.diagnostic_results" /> -->
                  <quillEditor v-model="form.diagnostic_results" :options="optionsEditor" />
                </div>
              </div>
              <div class="cs-flex">
                <div class="col-12">
                  <span class="cs-label">Sample type/ <i>Dạng mẫu</i></span>
                  <div class="d-flex cs-content">
                    <b-form-radio class="mr-1" v-model="form.diagnose_type" name="some-radios" :value="1"><label>Dịch ối/gai nhau</label></b-form-radio>
                    <b-form-radio class="mr-1" v-model="form.diagnose_type" name="some-radios" :value="2"><label>Máu/dịch</label></b-form-radio>
                    <b-form-radio class="mr-1" v-model="form.diagnose_type" name="some-radios" :value="3"><label>Mô</label></b-form-radio>
                  </div>
                </div>
              </div>
            </div>
            <!-- PATIENT INFORMATION -->            
          </div>          
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import { mapState } from "vuex";

const DEFAULT_FORM = {
  full_name: "",
  birthday: "",
  address: "",
  phone_number: "",
  email: "",
  doctor_name: "",
  clinic: "",
  doctor_phone_number: null,
  diagnostic_results: "",
  diagnose_type: null
};

const optionsEditor = {
  placeholder: "",
  theme: "snow"
};

export default {
  name: "CreateBloodSampleForm",
  props: {
    productData: Object,
    createRequisitionFormCount: Number,
    formCount: Number,
    formData: Object,
    formName: String
  },
  components: { quillEditor },
  data() {
    return {
      form: { ...DEFAULT_FORM },
      optionsEditor
    };
  },
  computed: {
    ...mapState({
      orders: state => state.orders
    })
  },
  watch: {
    createRequisitionFormCount() {
      this.handleCreateRequisitionForm();
    },
    formCount(count) {
      if (!count) return;
      this.handleGetFormData();
    },
    orders: {
      deep: true,
      handler(data) {
        if (data?.viewDetail) {
          this.handleMapData(data?.viewDetail);
        }
      }
    }
  },
  mounted() {
    if (this.orders?.viewDetail) {
      this.handleMapData(this.orders.viewDetail, this.formData);
    }
  },
  methods: {
    handleChangeSolidTumourType(isChecked, index) {
      if (isChecked) {
        this.form.solid_tumour_type.push(index);
      } else {
        this.form.solid_tumour_type = this.form.solid_tumour_type.filter(
          item => item !== index
        );
      }
    },
    handleChangeHaematologicalTumourType(isChecked, index) {
      if (isChecked) {
        this.form.haematological_tumour_type.push(index);
      } else {
        this.form.haematological_tumour_type = this.form.haematological_tumour_type.filter(
          item => item !== index
        );
      }
    },
    handleCreateRequisitionForm() {
      if (this.createRequisitionFormCount) {
        this.$emit("onCreate", this.form);
      } else {
        this.form = { ...DEFAULT_FORM };
      }
    },
    handleMapData(data, formData) {
      if (formData) {
        this.form = { ...this.form, ...formData };
      }
      const patientInfo =
        data?.order_contact?.find(item => item?.type === 2) ||
        data?.order_contact?.find(item => item?.type === 1);
      this.form.full_name = formData?.full_name || patientInfo?.name;
      this.form.address = formData?.address ||
        patientInfo?.address1 ||
        patientInfo?.address2;
      this.form.phone_number = formData?.phone_number || patientInfo?.phone;
      this.form.email = formData?.email || patientInfo?.email;
    },
    handleGetFormData() {
      this.$emit("onChangeFormData", this.form);
    }
  }
};
</script>

<style lang="scss" scoped>
.title-form {
  font-size: 24px;
  color: black;
  text-align: center;
}
label {
  font-size: 14px;
}
.cs-container {
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;

  * {
    color: black;
    font-family: "Times New Roman", "Tinos", Times, serif !important;
  }

  #printOrderForm {
    margin: auto;
    // margin-top: 100px;
    padding-left: 20px;
    padding-right: 20px;
  }

  h2 {
    // color: black;
    font-size: 28px;
  }
}

.container-border {
  border: 1px solid #5c5c5c;
  padding: 0;
  width: 50%;
}

.cs-title {
  display: block;
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 6px;
}

.cs-flex {
  display: flex;
  padding: 6px;
  box-sizing: border-box;
  align-items: center;
  flex-wrap: wrap;
}

.cs-label {
  width: 150px;
}

.cs-width-full {
  width: 100% !important;
}

.cs-font-bold {
  font-weight: bold;
}

.cs-checkbox {
  display: flex;
  align-items: center;

  input {
    width: 18px;
    height: 18px;
  }

  input[type="checkbox"] {
    accent-color: #20419b;
  }

  label {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    margin-left: 6px;
  }
}

.cs-content {
  flex: 1;
}

.min-checkbox {
  min-width: 120px;
}
.box-content {
  display: block;
  padding: 6px;
  min-height: 120px;
}
.html2pdf__page-break {
  page-break-before: always;
}

.cs-padding {
  padding: 6px;
}

.cs-border {
  border: 1px solid #5c5c5c;
}

.content-none {
  width: 100%;
  border-bottom: 2px dashed;
}

.cs-text-sm {
  font-size: 11px;
  font-weight: 500;
}

.cs-text-md {
  font-size: 16px;
}

.cs-list {
  display: flex;
  gap: 12px;
}

.cs-ol {
  li {
    position: relative;
    padding-left: 10px;
    margin-left: 15px;
  }

  li:before {
    position: absolute;
    left: -2px;
  }
}

.cs-none {
  pointer-events: none;
}
.w-30 {
  width: 30%;
}
.flex-grow-2 {
  flex-grow: 2;
}

@media (max-width: 576px) {
  .w-30 {
    width: 100%;
  }
  .d-flex {
    flex-wrap: wrap;
  }
  .cs-label {
    width: 100px;
  }
}
</style>
<style>
@media print {
  body {
    -webkit-print-color-adjust: exact;
  }
}
</style>